import React, { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { optionsPropTypes } from './SelectPropTypes'
import { clearCustomers, getCustomerBusAssignmentChanger } from '../../../../actions'
import Select from './Select'

const CustomerSelectBusAssignmentChangerSelect = ({
  dispatchGetCustomerBusAssignmentChanger,
  dispatchClearCustomers,
  options,
  loading,
  ...rest
}) => {

  useLayoutEffect(() => {
    dispatchGetCustomerBusAssignmentChanger();
    return () => {
      dispatchClearCustomers();
    };
  }, []);

  return (
    <Select
      options={options}
      isLoading={loading}
      {...rest}
    />
  )
}

CustomerSelectBusAssignmentChangerSelect.propTypes = {
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool,
  dispatchGetCustomerBusAssignmentChanger: PropTypes.func.isRequired,
  dispatchClearCustomers: PropTypes.func.isRequired,
}

CustomerSelectBusAssignmentChangerSelect.defaultProps = {
  loading: false,
}

const mapStateToProps = ({ UserUnit }) => ({
  loading: UserUnit.Customer.getIn(['all', 'loading']),
  options: UserUnit.Customer.getIn(['all', 'content', 'content']).map(customer => ({
    value: customer.id,
    label: customer.fullName,
  })),
})

const mapDispatchToProps = {
  dispatchGetCustomerBusAssignmentChanger: getCustomerBusAssignmentChanger,
  dispatchClearCustomers: clearCustomers
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSelectBusAssignmentChangerSelect);
